type EcommerceSettingMappingAttributes = {
    settingMappings: CustomSettingAttributes
    type: string
}

export type CustomSettingAttributes = {
    showUnitPrice: boolean
    showLineSubtotal: boolean
    showCartSubtotal: boolean
}

export type EcommerceSettingMappingDto = {
    id: string,
    type: string,
    attributes: EcommerceSettingMappingAttributes
}
export default class EcommerceSettingMapping {
    private dto: EcommerceSettingMappingDto
    constructor(dto: EcommerceSettingMappingDto) {
        this.dto = dto
    }

    getType(): string {
        return this.dto.attributes.type
    }

    getAttributes(): CustomSettingAttributes {
        return this.dto?.attributes?.settingMappings
    }

    setAttribute(setting: string, value: boolean) {
        this.dto.attributes.settingMappings[setting] = value
    }


}


// WEBPACK FOOTER //
// ./src/state/ecommerce-configuration/EcommerceSettingMapping.ts